import { Injectable } from "@angular/core";
import { RouterStateSnapshot, ActivatedRouteSnapshot, Router, Data } from '@angular/router';
import { UserService } from "..";

@Injectable()
export class AdminGuard  {
    constructor(private userService: UserService, private router: Router) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.userService.isLoggedIn() && this.userService.isUserAdmin()) {
            return true;
        }
        return false;
    }
}
